<template>
	<header class="header">
		<!-- <div class="header-top">
			<div :class="isFullwidth ? 'container-fluid' : 'container'">
				<div class="header-left">
					<div class="header-dropdown">
						<a href="#">Usd</a>
						<div class="header-menu">
							<ul>
								<li><a href="#">Eur</a></li>
								<li><a href="#">Usd</a></li>
							</ul>
						</div>
					</div>

					<div class="header-dropdown">
						<a href="#">Eng</a>
						<div class="header-menu">
							<ul>
								<li><a href="#">English</a></li>
								<li><a href="#">French</a></li>
								<li><a href="#">Spanish</a></li>
							</ul>
						</div>
					</div>
				</div>

				<div class="header-right">
					<ul class="top-menu">
						<li>
							<a href="#">Links</a>
							<ul>
								<li><a href="tel:#"><i class="icon-phone"></i>Call: +27 82 440 9174</a></li>
								<li>
									<nuxt-link to="/about-us">About Us</nuxt-link>
								</li>
								<li>
									<nuxt-link to="/contact-us">Contact Us</nuxt-link>
								</li>
								<li><a
										href="#signin-modal"
										@click.prevent="openSignInModal"
									><i class="icon-user"></i>Login</a></li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
		</div> -->
		<div class="sticky-container">
			<sticky-header>
				<div class="header-middle sticky-header">
					<div :class="isFullwidth ? 'container-fluid' : 'container'">
						<div class="header-left">
							<button
								class="mobile-menu-toggler"
								@click="openMobileMenu"
							>
								<span class="visually-hidden-focusable">Toggle mobile menu</span>
								<i class="icon-bars"></i>
							</button>

							<nuxt-link
								to="/"
								class="logo"
							>
								<img
									v-lazy="'/images/home/logo.png'"
									class="bg-transparent"
									alt="Airabica Logo"
									width="82"
									height="20"
								/>
							</nuxt-link>
						</div>

						<div class="header-center">
							<main-menu></main-menu>
						</div>

						<div class="header-right">
							<header-search></header-search>

							<cart-menu></cart-menu>
						</div>
					</div>
				</div>
			</sticky-header>
		</div>
	</header>
</template>

<script>
import CartMenu from '~/components/partial/headers/shared/CartMenu';
import MainMenu from '~/components/partial/headers/shared/MainMenu';
import HeaderSearch from '~/components/partial/headers/shared/HeaderSearch';
import StickyHeader from '~/components/elements/StickyHeader';

export default {
	components: {
		CartMenu,
		MainMenu,
		HeaderSearch,
		StickyHeader
	},
	computed: {
		isFullwidth: function() {
			return this.$route.path.includes('fullwidth');
		}
	},
	methods: {
		openSignInModal: function() {
			this.$modal.show(
				() => import('~/components/elements/modals/SignInModal'),
				{},
				{ width: '575', height: 'auto', adaptive: true }
			);
		},
		openMobileMenu: function() {
			document.querySelector('body').classList.add('mmenu-active');
		}
	}
};
</script>